<script setup lang="ts">
// The MerchantApp admin bar: UserManagementUI's `shared/AdminBar` component,
// mounted through the same legacy AppMount contract as its pages but with
// `componentPath`, exactly as MerchantApp's AdminBarMfe does. Rendered only
// for admin users; the remote decides what the bar shows (impersonation,
// actions) from the host-provided auth service and $hostRouter.
import { computed, ref } from "vue";
import { useUserStore } from "../../shared/user/user.store";
import { getConfiguredRemotes } from "../../shared/federation/remote-registry";
import LegacyRemoteMount from "../../shared/legacy/LegacyRemoteMount.vue";
import styles from "./AdminBar.module.css";

const ADMIN_BAR_REMOTE_ID = "userManagementUi";
const ADMIN_BAR_COMPONENT_PATH = "shared/AdminBar";

const userStore = useUserStore();
const remote = computed(() =>
  getConfiguredRemotes().find(
    (entry) => entry.id === ADMIN_BAR_REMOTE_ID && entry.mode === "legacy",
  ),
);
const isVisible = computed(() => userStore.isAdmin && remote.value !== undefined);
// The bar's row is reserved only once the remote has mounted: UserManagementUI
// can take a while to load, and an empty reserved row reads as a blank band.
const isReady = ref(false);
</script>

<template>
  <div v-if="isVisible && remote" :class="isReady && styles.adminBar" data-testid="admin-bar">
    <LegacyRemoteMount
      :remote-id="remote.id"
      :remote-name="remote.remoteName"
      :mount-path="`${remote.alias || remote.remoteName}/AppMount`"
      :mount-options="{ componentPath: ADMIN_BAR_COMPONENT_PATH }"
      hide-loading
      @ready="isReady = true"
    />
  </div>
</template>
